import { useCallback, useEffect, useRef, useState } from 'react';
import styles from './Cursor.module.scss';

function Cursor({ state2, activeSection }) {
	const [coords, setCoords] = useState({ x: -1000, y: -1000 });
	const [hidden, setHidden] = useState(false);
	const ticking = useRef(false);

	function update({ clientX, clientY }) {
		setCoords({ x: clientX, y: clientY });
		setHidden(false);
		ticking.current = false;
	}

	const onMouseMove = useCallback((e) => {
		if (ticking.current) return;
		ticking.current = true;
		requestAnimationFrame(() => update(e));
	}, []);

	const onMouseLeave = ({ relatedTarget }) => {
		if (relatedTarget === null) setHidden(true);
	};

	useEffect(() => {
		window.addEventListener('mousemove', onMouseMove);
		window.addEventListener('mouseout', onMouseLeave);

		return () => {
			window.removeEventListener('mousemove', onMouseMove);
			window.removeEventListener('mouseout', onMouseLeave);
		};
	}, [onMouseMove]);

	return (
		<div
			style={{ transform: `translate(${coords.x}px, ${coords.y}px)` }}
			className={[
				styles.wrapper,
				hidden && styles.hidden,
				state2 && styles.state2,
			]
				.filter(Boolean)
				.join(' ')}
		>
			<div className={styles.circle}></div>
			<div className={styles.text}>{activeSection.title}</div>
		</div>
	);
}

export default Cursor;
